module.exports = __webpack_public_path__ + "static/media/creeper-two.62c3f15f.png";